import React from 'react';
import { HashRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import InquiryForm from './inquiry/form';

// components

export default (props) => {
    const routes = [{
        path: '/inquiry/:arg1',
        Component: InquiryForm,
    }];

    return (
        <Router>
            <div>
                <Switch>
                    <Redirect from="/" to="/inquiry/form" exact/>
                    {routes.map(({ path, Component }, key) => <Route exact path={path} component={Component} key={key} />)}
                </Switch>
            </div>
        </Router>
    );
};